import script from "./updateDetailDescPop.vue?vue&type=script&setup=true&name=updateDetailDescPop&lang=js"
export * from "./updateDetailDescPop.vue?vue&type=script&setup=true&name=updateDetailDescPop&lang=js"

const __exports__ = script;

export default __exports__